module.exports = __webpack_public_path__ + "media/charts/ISSUESADDRESSED-da5c880a.svg";